import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft, SearchX } from "lucide-react";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#020617] via-gray-900 to-black text-white">
      <div className="flex items-center justify-center px-3 sm:px-4 py-12 sm:py-20">
        <div className="max-w-2xl w-full rounded-2xl sm:rounded-3xl bg-gray-950/80 border border-red-500/20 shadow-[0_0_24px_rgba(239,68,68,0.08)] overflow-hidden">
          <div className="p-6 sm:p-8 md:p-10 text-center">
            <div className="inline-flex items-center justify-center h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-red-500/20 border border-red-400/40 mb-4 sm:mb-6">
              <SearchX className="h-8 w-8 sm:h-10 sm:w-10 text-red-300" />
            </div>
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-red-400 mb-3 sm:mb-4">
              404
            </h1>
            
            <p className="text-xl sm:text-2xl font-semibold text-white mb-2">
              Page Not Found
            </p>
            
            <p className="text-sm sm:text-base text-gray-300 leading-relaxed mb-6 sm:mb-8">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center gap-2 rounded-xl sm:rounded-2xl bg-gray-900/90 hover:bg-gray-800 text-white px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold border border-white/10 transition-all active:scale-95"
              >
                <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" />
                Go Back
              </button>
              
              <button
                onClick={() => navigate("/")}
                className="inline-flex items-center justify-center gap-2 rounded-xl sm:rounded-2xl bg-emerald-500 hover:bg-emerald-600 text-white px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold transition-all active:scale-95"
              >
                <Home className="h-4 w-4 sm:h-5 sm:w-5" />
                Return Home
              </button>
            </div>
          </div>

          <div className="px-6 sm:px-8 md:px-10 py-4 border-t border-white/5 text-center text-xs sm:text-sm text-gray-500">
            Lost? Try searching from the home page or check the navigation menu.
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
